import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faTimesCircle, faTrash } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CheckBox } from 'devextreme-react/check-box';
import { NumberBox } from 'devextreme-react/number-box';
import { CatchWeightOptions } from 'enums';
import React, { FC } from 'react';
import { CatchWeight, ReconcileReason } from 'services/types';
import './catch-weight-item.scss';

type Props = {
    catchWeight: CatchWeight,
    reconcileReasons: ReconcileReason[],
    onClickOperationMode: (options: CatchWeightOptions, id: number, editedWeight: number) => void
}

export const CatchWeightItem: FC<Props> = ({ catchWeight, reconcileReasons, onClickOperationMode = () => { } }) => {

    const maxCatchWeightValue = 9999.9999;

    let localCatchWeight = { ...catchWeight };
    let commentColor: string = '';
    let comments: string = '';
    let index: number = reconcileReasons.findIndex(reasons => reasons.id == catchWeight.reconcileReasonId);

    switch (catchWeight.catchWeightOptions) {
        case CatchWeightOptions.Add:
            commentColor = 'Green'
            comments = index >= 0 ? reconcileReasons[index].description : ''
            break;
        case CatchWeightOptions.Edit:
            commentColor = '#F2994A'
            comments = catchWeight.shippedWeight.toString()  // Need to add the description 
            break;
        case CatchWeightOptions.Delete:
            commentColor = '#EB5757'
            comments = index >= 0 ? reconcileReasons[index].description : ''
            break;
        case CatchWeightOptions.Undo:
            break;
        case CatchWeightOptions.Verified:
            commentColor = '#76AB21'
            comments = "Verified"
            break;
    }

    const handleKeyUp = (e: any) => {
        if (catchWeight.catchWeightOptions === CatchWeightOptions.Add)
            onClickOperationMode(CatchWeightOptions.Add, catchWeight.id, e.value)
        else
            onClickOperationMode(CatchWeightOptions.Edit, catchWeight.id, e.value)
    }

    return (
        <div className={'catch-weight-list'}>
            <div className={'catch-weight-checkbox'}>
                <CheckBox name={catchWeight.id.toString()} disabled={catchWeight.isVerified} value={catchWeight.isVerified} onValueChanged={e => e.event && onClickOperationMode(CatchWeightOptions.Verified, catchWeight.id, catchWeight.shippedWeight)} />
            </div>
            <div className={'catch-weight-textbox'}>
                <NumberBox
                    disabled={catchWeight.isVerified}
                    value={localCatchWeight.adjustedWeight ? localCatchWeight.adjustedWeight : localCatchWeight.shippedWeight}
                    onValueChanged={(e: any) => {
                        let value = localCatchWeight.adjustedWeight ? localCatchWeight.adjustedWeight : localCatchWeight.shippedWeight;

                        if (e.value > maxCatchWeightValue || (value as number) === (e.value as number)) {
                            return;
                        }

                        handleKeyUp(e)
                    }}
                    width='95%'
                />
            </div>
            <div className={'catch-weight-comments'} style={{ color: commentColor }}>
                {comments}
            </div>
            <div className={'catch-weight-icon'}>
                {catchWeight.isVerified ?
                    <FontAwesomeIcon icon={faTimesCircle as IconProp} size={'1x'} color={'black'} onClick={() => onClickOperationMode(CatchWeightOptions.Undo, catchWeight.id, catchWeight.shippedWeight)} />
                    :
                    <FontAwesomeIcon icon={faTrash as IconProp} size={'1x'} color={'#EB5757'} onClick={() => onClickOperationMode(CatchWeightOptions.Delete, catchWeight.id, catchWeight.shippedWeight)} />
                }
            </div>
        </div>
    )
}